import React from 'react';
import { Twitter, Instagram, Linkedin, Github } from 'lucide-react';
export function Footer() {
  return <footer className="bg-[#1a1a2e] text-white py-12 border-t border-white/10" data-id="element-55">
      <div className="max-w-7xl mx-auto px-6" data-id="element-56">
        <div className="flex flex-col md:flex-row justify-between items-center gap-8" data-id="element-57">
          <div className="text-center md:text-left" data-id="element-58">
            <h2 className="text-2xl font-extrabold tracking-tight mb-2" data-id="element-59">
              Nexora<span className="text-[#FF6B35]" data-id="element-60">Virtual</span>
            </h2>
            <p className="text-gray-400 text-sm max-w-xs mb-4" data-id="element-61">
              Building digital experiences that move people. Mobile apps &
              WordPress solutions.
            </p>
            <div className="text-gray-500 text-sm space-y-1" data-id="element-62">
              <p data-id="element-63">London, UK</p>
              <p data-id="element-64">+44 7921 876472</p>
              <p data-id="element-65">admin@nexoravirtual.com</p>
            </div>
          </div>

          <div className="flex items-center space-x-6" data-id="element-66">
            <a href="#" className="text-gray-400 hover:text-[#FF6B35] transition-colors" data-id="element-67">
              <Twitter size={24} data-id="element-68" />
            </a>
            <a href="#" className="text-gray-400 hover:text-[#FF6B35] transition-colors" data-id="element-69">
              <Instagram size={24} data-id="element-70" />
            </a>
            <a href="#" className="text-gray-400 hover:text-[#FF6B35] transition-colors" data-id="element-71">
              <Linkedin size={24} data-id="element-72" />
            </a>
            <a href="#" className="text-gray-400 hover:text-[#FF6B35] transition-colors" data-id="element-73">
              <Github size={24} data-id="element-74" />
            </a>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-white/10 text-center text-gray-500 text-sm" data-id="element-75">
          <p data-id="element-76">
            &copy; {new Date().getFullYear()} Nexora Virtual. All rights
            reserved.
          </p>
        </div>
      </div>
    </footer>;
}